import type { IProductComponentsService } from './IProductComponentsService';
import type { ProductComponentDto } from '../dto/ProductComponent.dto';
import type { SetProductComponentRequest } from '../dto/SetProductComponentRequest';

import { JsonRequestBody } from '../http/JsonRequestBody';
import { ProductComponentsEndpoints } from './ProductComponentsEndpoints';

// @ts-ignore
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';

export class ProductComponentsService implements IProductComponentsService {
    async list(productExternalId: string): Promise<ProductComponentDto[]> {
        return fetchWithAuth(
            ProductComponentsEndpoints.list(productExternalId),
            {
                method: 'GET',
            },
        );
    }

    async set(
        productExternalId: string,
        payload: SetProductComponentRequest[],
    ): Promise<ProductComponentDto[]> {
        return fetchWithAuth(
            ProductComponentsEndpoints.set(productExternalId),
            {
                method: 'PUT',
                ...JsonRequestBody.from(payload),
            },
        );
    }
}